<template>
  <div class="upload">
    <el-upload
    name="file"
    class="avatar-uploader"
    :action="action"
    :show-file-list="false"
    accept=".xls,.xlsx"
    :onError="uploadError"
    :onSuccess="uploadSuccess"
    :before-upload="beforeAvatarUpload">
      <el-button type="primary" plain icon="el-icon-upload" :size="size">批量导入</el-button>
    </el-upload>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  props: {
    size: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      action: Vue.prototype.global.Url_UploadExcel
    }
  },
  methods: {
    beforeAvatarUpload (file) {
      const fileName = file.name ? file.name.toLowerCase() : ''
      const isExcel = fileName.endsWith('.xls') || fileName.endsWith('.xlsx') ||
        file.type === 'application/vnd.ms-excel' ||
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const isLt20M = file.size / 1024 / 1024 < 20

      if (!isExcel) {
        this.$message.error('上传文件只能是 xls 或 xlsx 格式!')
      }
      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB!')
      }

      return isExcel && isLt20M
    },
    uploadSuccess (response, file, fileList) {
      this.$emit('change', response)
    },
    uploadError (response, file, fileList) {
      this.$message.error('上传失败')
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader{
  display: inline-block;
}
// /deep/ .el-upload {
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
// }
// /deep/ .el-upload:hover {
//     border-color: #409EFF;
// }

.upload{
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
}
</style>
